module.exports = "<pre><code class=\"lang-bash\">$ npm install vue-stepper-component --save\n</code></pre>\n";


//////////////////
// WEBPACK FOOTER
// ./src/markdowns/install.md
// module id = yypm
// module chunks = 1